import { onBeforeUnmount, watch, WatchSource } from "vue";

/**
 * Bloque le défilement de la page tant qu'une fenêtre est ouverte (Modal, Sheet).
 * Verrou partagé : plusieurs fenêtres peuvent être ouvertes en même temps, la page ne
 * redéfile qu'à la fermeture de la dernière, avec ses styles d'origine.
 * `overflow: hidden` est posé sur <html> (défilement de la page) et sur <body> (convention
 * lue ailleurs, ex. marketplace/mobile-scroll-chrome.ts).
 */
let locks = 0;
let saved: { html: string; body: string } | null = null;

const lock = () => {
    locks += 1;
    if (locks > 1) {
        return;
    }
    const { documentElement: html, body } = document;
    saved = { html: html.style.overflow, body: body.style.overflow };
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
};

const unlock = () => {
    if (locks === 0) {
        return;
    }
    locks -= 1;
    if (locks === 0 && saved) {
        document.documentElement.style.overflow = saved.html;
        document.body.style.overflow = saved.body;
        saved = null;
    }
};

export function useScrollLock(active: WatchSource<boolean>) {
    let held = false;

    const set = (value: boolean) => {
        if (typeof document === "undefined" || value === held) {
            return;
        }
        held = value;
        if (value) {
            lock();
        } else {
            unlock();
        }
    };

    watch(active, set, { immediate: true });
    onBeforeUnmount(() => set(false));
}
